import { Button, Drawer, Form, Modal, Pagination, Tabs } from "antd";
import dayjs from "dayjs";
import { useState } from "react";
import Router from "../..";
import { useHistory } from "react-router-dom";
import {
  useAppliedCampaignsByInfluencer,
  useCampaignListByInfluencer,
  useCancelCampaignByInfluencer,
  useRejectCampaignInvitationByInfluencer,
  useUpdateShipmentByInfluencer,
} from "../../hooks/useCampaign";
import { DELIVERY_MESSAGE_OPTIONS } from "../../components/campaign/CampaignShipmentForm";

export const MyCampaign = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [currentStatus, setCurrentStatus] = useState(null);
  const [isDetailDrawerVisible, setIsDetailDrawerVisible] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [showApplyForm, setShowApplyForm] = useState(false);
  const [showInvitationContent, setShowInvitationContent] = useState(false);
  const [form] = Form.useForm();
  const [shipmentForm] = Form.useForm();
  const [isShipmentEditMode, setIsShipmentEditMode] = useState(false);
  const pageSize = 20;
  const history = useHistory();

  const { mutateAsync: rejectInvitation } =
    useRejectCampaignInvitationByInfluencer();
  const { mutateAsync: updateShipment } = useUpdateShipmentByInfluencer();
  const { mutateAsync: cancelCampaign } = useCancelCampaignByInfluencer();

  const { data: appliedData } = useAppliedCampaignsByInfluencer({
    campaignId: selectedCampaign?.id,
    enabled: !!selectedCampaign?.id,
  });
  const appliedCampaigns = appliedData?.result;
  const shipment = appliedData?.shipment ?? null;

  const { data: campaignsData } = useCampaignListByInfluencer({
    page: currentPage,
    status: currentStatus === "all" ? null : currentStatus,
  });
  const campaigns = campaignsData?.result ?? [];
  const total = campaignsData?.total ?? 0;

  const handleCancelCampaign = async (campaignId) => {
    Modal.confirm({
      title: "캠페인 신청 취소",
      content: "정말로 이 캠페인 신청을 취소하시겠습니까?",
      okText: "취소하기",
      okType: "danger",
      cancelText: "돌아가기",
      onOk: async () => {
        await cancelCampaign({ id: campaignId });
      },
    });
  };

  const handleAcceptInvitation = async (campaignId) => {
    history.replace(`/campaign/search?campaign_id=${campaignId}&apply=true`);
  };

  const handleRejectInvitation = async (campaignId) => {
    Modal.confirm({
      title: "초대 거절",
      content: "정말로 이 캠페인 초대를 거절하시겠습니까?",
      okText: "거절하기",
      okType: "danger",
      cancelText: "돌아가기",
      onOk: async () => {
        const success = await rejectInvitation(campaignId);
        if (success) {
          setIsDetailDrawerVisible(false);
          setShowInvitationContent(false);
        }
      },
    });
  };

  const handleShipmentUpdate = async (values) => {
    const deliveryMessage =
      values.delivery_message_type === "custom"
        ? values.delivery_message
        : values.delivery_message_type;

    const shipmentData = {
      id: shipment.id,
      receiver_name: values.receiver_name,
      receiver_phone: values.receiver_phone,
      receiver_country: values.country,
      receiver_street_address: values.street_address,
      receiver_address_line: values.address_line,
      receiver_city: values.city,
      receiver_state_province: values.state_province,
      receiver_postal_code: values.postal_code,
      customs_clearance_number: values.customs_clearance_number,
      delivery_message: deliveryMessage,
    };

    const success = await updateShipment(shipmentData);

    if (success) {
      setIsShipmentEditMode(false);
      shipmentForm.resetFields();
    }
  };

  return (
    <div>
      <h2 className="md:text-4xl text-3xl font-bold">나의 캠페인</h2>

      <Tabs
        defaultActiveKey="all"
        onChange={(key) => {
          setCurrentStatus(key === "all" ? null : key);
          setCurrentPage(1);
        }}
        className="font-normal mb-5"
        items={[
          { key: "all", label: "전체" },
          { key: "pending", label: "검토 중" },
          { key: "accepted", label: "승인" },
          { key: "rejected", label: "거절" },
          { key: "invited", label: "초대 내역" },
        ]}
      />

      <div className="grid grid-cols-2 xl:grid-cols-4 2xl:grid-cols-5 gap-[15px] md:gap-[25px]">
        {campaigns
          ? campaigns.map((campaign) => (
              <Router.CampaignCard
                key={campaign.id}
                campaign={campaign}
                variant="my-campaign"
                selected={selectedCampaign?.id === campaign.id}
                onClick={() => {
                  setShowApplyForm(false);
                  setShowInvitationContent(false);
                  setSelectedCampaign(campaign);
                  setIsDetailDrawerVisible(true);
                }}
                // onActionDetail={(c) => {
                //   setSelectedCampaign(c);
                //   setShowApplyForm(false);
                //   setShowInvitationContent(false);
                //   setIsDetailDrawerVisible(true);
                // }}
                // onActionInvitation={(c) => {
                //   setSelectedCampaign(c);
                //   setShowInvitationContent(true);
                //   setShowApplyForm(false);
                //   setIsDetailDrawerVisible(true);
                // }}
                // onActionHistory={(c) => {
                //   setSelectedCampaign(c);
                //   setShowApplyForm(true);
                //   setShowInvitationContent(false);
                //   setIsDetailDrawerVisible(true);
                // }}
                // onActionCancel={handleCancelCampaign}
              />
            ))
          : []}
      </div>

      <Drawer
        title={
          showInvitationContent
            ? "초대 내용"
            : showApplyForm
              ? "나의 신청 내역"
              : "캠페인 상세보기"
        }
        placement="right"
        onClose={() => {
          setIsDetailDrawerVisible(false);
          setSelectedCampaign(null);
          setShowApplyForm(false);
          setShowInvitationContent(false);
          form.resetFields();
          shipmentForm.resetFields();
          setIsShipmentEditMode(false);
        }}
        open={isDetailDrawerVisible}
        width={600}
        maskClosable={true}
        mask={false}
        extra={
          <div className="flex gap-2">
            {showInvitationContent ? (
              <Button
                type="primary"
                onClick={() => {
                  setShowInvitationContent(false);
                }}
              >
                캠페인 상세보기
              </Button>
            ) : showApplyForm ? (
              <Button
                type="primary"
                onClick={() => {
                  setShowApplyForm(false);
                }}
              >
                캠페인 상세보기
              </Button>
            ) : (
              <Button
                type="primary"
                onClick={() => {
                  if (selectedCampaign?.invitation_status === "invited") {
                    setShowInvitationContent(true);
                  } else {
                    setShowApplyForm(true);
                  }
                }}
              >
                {selectedCampaign?.invitation_status === "invited"
                  ? "초대 내용 보기"
                  : "나의 신청 내역 보기"}
              </Button>
            )}
          </div>
        }
      >
        {selectedCampaign && (
          <>
            {showInvitationContent ? (
              <div>
                <div className="flex justify-between items-center mb-6 bg-[#f8f9fa] px-6 py-4 rounded-lg">
                  <div className="text-[15px]">
                    초대일 :{" "}
                    {selectedCampaign.invited_at
                      ? dayjs(selectedCampaign.invited_at).format(
                          "YYYY년 MM월 DD일 HH:mm"
                        )
                      : "-"}
                  </div>
                  <div className="px-4 py-1.5 rounded-full text-[14px] bg-[#e3f2fd] text-[#1976d2]">
                    초대됨
                  </div>
                </div>
                <div className="mb-6">
                  <h3 className="mb-3 text-[#424242]">초대 메시지</h3>
                  <div className="whitespace-pre-line p-5 bg-white rounded-lg border border-[#e0e0e0] text-[14px] leading-[1.6]">
                    {selectedCampaign.message || "초대 메시지가 없습니다."}
                  </div>
                </div>
                <div className="flex gap-3 justify-end mt-8">
                  <Button
                    onClick={() => handleRejectInvitation(selectedCampaign.id)}
                    danger
                  >
                    초대 거절
                  </Button>
                  <Button
                    type="primary"
                    onClick={() => handleAcceptInvitation(selectedCampaign.id)}
                  >
                    초대 수락
                  </Button>
                </div>
              </div>
            ) : showApplyForm ? (
              <div>
                <Router.MyCampaignApplyDetail
                  selectedCampaign={selectedCampaign}
                  appliedCampaigns={appliedCampaigns}
                />
                {appliedCampaigns?.status === "pending" ? (
                  <div className="mt-6 flex justify-end">
                    <Button
                      danger
                      onClick={() => handleCancelCampaign(selectedCampaign.id)}
                    >
                      신청 취소
                    </Button>
                  </div>
                ) : null}
                {/* 배송정보가 있으면 수정 Form 추가 */}
                {shipment && appliedCampaigns?.status !== "pending" ? (
                  <>
                    <div className="flex justify-between items-center mb-3 mt-6">
                      <h3 className="text-[#424242]">배송 정보</h3>
                      <div className="flex gap-2 min-h-[32px] items-center">
                        {!isShipmentEditMode &&
                          shipment.tracking_number === null && (
                            <Button
                              size="small"
                              onClick={() => {
                                setIsShipmentEditMode(true);

                                const preset = DELIVERY_MESSAGE_OPTIONS.find(
                                  (o) =>
                                    o.value !== "custom" &&
                                    o.value === shipment.delivery_message
                                );
                                const deliveryMessageType = preset
                                  ? preset.value
                                  : "custom";
                                const deliveryMessage = preset
                                  ? ""
                                  : shipment.delivery_message || "";

                                shipmentForm.setFieldsValue({
                                  receiver_name: shipment.receiver_name,
                                  receiver_phone: shipment.receiver_phone,
                                  country: shipment.receiver_country,
                                  state_province:
                                    shipment.receiver_state_province,
                                  city: shipment.receiver_city,
                                  postal_code: shipment.receiver_postal_code,
                                  street_address:
                                    shipment.receiver_street_address,
                                  address_line: shipment.receiver_address_line,
                                  customs_clearance_number:
                                    shipment.customs_clearance_number || "",
                                  delivery_message_type: deliveryMessageType,
                                  delivery_message: deliveryMessage,
                                });
                              }}
                            >
                              수정
                            </Button>
                          )}
                        {!isShipmentEditMode &&
                          shipment.tracking_number !== null && (
                            <Button
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                const url = `/shipment-tracking?campaign_recruitment_id=${shipment.campaign_recruitment_id}`;
                                window.open(
                                  url,
                                  "배송추적",
                                  "width=450, height=900, scrollbars=yes, resizable=yes"
                                );
                              }}
                            >
                              배송 조회
                            </Button>
                          )}
                        {isShipmentEditMode && (
                          <>
                            <Button
                              size="small"
                              onClick={() => {
                                setIsShipmentEditMode(false);
                                shipmentForm.resetFields();
                              }}
                            >
                              취소
                            </Button>
                            <Button
                              size="small"
                              type="primary"
                              onClick={() => shipmentForm.submit()}
                            >
                              완료
                            </Button>
                          </>
                        )}
                      </div>
                    </div>

                    {isShipmentEditMode ? (
                      <Form
                        form={shipmentForm}
                        onFinish={handleShipmentUpdate}
                        layout="vertical"
                        requiredMark={false}
                      >
                        <Router.CampaignShipmentForm />
                      </Form>
                    ) : (
                      <div className="p-5 bg-white rounded-lg border border-[#e0e0e0] text-[14px] leading-[1.6]">
                        <div className="mb-2">
                          <strong>수령인 이름:</strong> {shipment.receiver_name}
                        </div>
                        <div className="mb-2">
                          <strong>수령인 전화번호:</strong>{" "}
                          {shipment.receiver_phone}
                        </div>
                        <div className="mb-2">
                          <strong>국가:</strong> {shipment.receiver_country}
                        </div>
                        <div className="mb-2">
                          <strong>시/도:</strong>{" "}
                          {shipment.receiver_state_province}
                        </div>
                        <div className="mb-2">
                          <strong>시/군/구:</strong> {shipment.receiver_city}
                        </div>
                        <div className="mb-2">
                          <strong>우편번호:</strong>{" "}
                          {shipment.receiver_postal_code}
                        </div>
                        <div className="mb-2">
                          <strong>도로명 주소:</strong>{" "}
                          {shipment.receiver_street_address}
                        </div>
                        <div className="mb-2">
                          <strong>상세주소:</strong>{" "}
                          {shipment.receiver_address_line || "-"}
                        </div>
                        {shipment.customs_clearance_number && (
                          <div className="mb-2">
                            <strong>통관번호:</strong>{" "}
                            {shipment.customs_clearance_number}
                          </div>
                        )}
                        {shipment.delivery_message && (
                          <div className="mb-2">
                            <strong>배송 메시지:</strong>{" "}
                            {shipment.delivery_message}
                          </div>
                        )}
                      </div>
                    )}
                  </>
                ) : null}
              </div>
            ) : (
              //캠페인 상세보기
              <div>
                <Router.CampaignDetailInfo
                  selectedCampaign={selectedCampaign}
                  brandRecentVideos={selectedCampaign?.recent_tiktok_videos}
                />
              </div>
            )}
          </>
        )}
      </Drawer>

      <Pagination
        current={currentPage}
        total={total}
        pageSize={pageSize}
        onChange={(page) => setCurrentPage(page)}
        showSizeChanger={false}
        className="mt-12 justify-center"
      />
    </div>
  );
};
